import { rootApi } from "../rootApi";
import { DashboardStats, RecentActivity, UpcomingDeadline } from "./types";

// Mock data for dashboard stats
const mockDashboardStats: DashboardStats = {
  votingProxyEvents: {
    upcoming: 8,
    active: 12,
    recentlyCompleted: 5,
  },
  informationalProxyEvents: {
    upcoming: 3,
    active: 6,
    recentlyCompleted: 2,
  },
  noboEvents: {
    pendingApproval: 4,
    pendingDelivery: 7,
    recentlyDelivered: 11,
  },
  shareRangeAnalysisEvents: {
    pendingApproval: 5,
    pendingDelivery: 8,
    recentlyDelivered: 12,
  },
  locationAnalysisEvents: {
    pendingApproval: 3,
    pendingDelivery: 5,
    recentlyDelivered: 9,
  },
  bankruptcyEvents: {
    upcoming: 2,
    active: 4,
    recentlyCompleted: 3,
  },
  classActionEvents: {
    upcoming: 1,
    active: 3,
    recentlyCompleted: 2,
  },
};

export const dashboardApis = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    dashboardStats: builder.query<DashboardStats, void>({
      queryFn: () => {
        // Return mock data - replace with actual API call when backend is ready
        return { data: mockDashboardStats };
      },
      providesTags: ["dashboard"],
    }),
    recentActivity: builder.query<RecentActivity[], void>({
      query: () => ({ url: "dashboard/recent-activity/" }),
      providesTags: ["dashboard"],
    }),
    upcomingDeadlines: builder.query<UpcomingDeadline[], void>({
      query: () => ({ url: "dashboard/upcoming-deadlines/" }),
      providesTags: ["dashboard"],
    }),
  }),
});

export const {
  useDashboardStatsQuery,
  useRecentActivityQuery,
  useUpcomingDeadlinesQuery,
} = dashboardApis;
